import { MenuResponse } from '@/types/menu';
import axiosInstance from './axiosInstance';

const baseUrl = `${SUPP_ADMIN_BASE_URL}/supp-management`;

/**
 * 获取权限菜单列表
 * @returns {Promise<MenuResponse>} 返回菜单列表数据
 */
export const getMenuList = async (): Promise<MenuResponse> => {
  const response = await axiosInstance.get<MenuResponse>(`${baseUrl}/admin/menu/list`);
  return response.data;
};
